var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueryLogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 376.333c0-69.737-52.893-127.344-120.667-134.833v-60.833h-32.58c1.665-4.695 2.58-9.742 2.58-15s-.915-10.305-2.58-15h32.58v-150.667h-391.333v150.667h32.58c-1.665 4.695-2.58 9.742-2.58 15s.915 10.305 2.58 15h-32.58v150.667h32.58c-1.665 4.695-2.58 9.742-2.58 15s.915 10.305 2.58 15h-32.58v150.666h376.833c74.577-.277 135.167-61.027 135.167-135.667zm-482-346.333h331.333v90.667h-331.333zm30 135.667c0-8.271 6.729-15 15-15h241.333c8.271 0 15 6.729 15 15s-6.729 15-15 15h-241.333c-8.271 0-15-6.729-15-15zm-30 45h331.333v30.833c-40.844 4.513-76.279 27.228-97.993 59.834h-233.34zm30 135.666c0-8.271 6.729-15 15-15h173.347c-3.371 9.559-5.699 19.603-6.848 30h-166.502c-8.27-.001-14.997-6.729-14.997-15zm-30 135.667v-90.667h44.996 166.503c4.037 36.533 22.636 68.736 49.851 90.667zm346.333 0c-58.265 0-105.667-47.402-105.667-105.667s47.402-105.667 105.667-105.667 105.667 47.402 105.667 105.667-47.402 105.667-105.667 105.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.333 316.333h-30v75.167h75.167v-30h-45.167z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryLogs);
export default __webpack_public_path__ + "static/media/query_logs.4ab776938d03007269900d6d4427a1f4.svg";
export { ForwardRef as ReactComponent };